import {
	ReadonlyRefObject,
	useEffect,
	useState
} from "react";
import {
	registerSizeListener,
	ResizeCallback,
	SizeInformation
} from "client_legacy/ndaw/sizing";

export type ResizeObserverResult = SizeInformation & {
	wasInitialized: boolean;
};

export const useResizeObserver = <T extends HTMLElement>(
	ref: ReadonlyRefObject<T | null>
): ResizeObserverResult => {
	const [size, setSize] = useState<ResizeObserverResult>({
		width: 0,
		height: 0,
		wasInitialized: false,
	});

	const onResize: ResizeCallback = (newSize: SizeInformation) => {
		setSize({
			...newSize,
			wasInitialized: true
		});
	};

	useEffect(
		() => {
			const setElement: T | null = ref.current;
			if (!setElement) {
				return undefined;
			}

			return registerSizeListener(setElement, onResize);
		},
		[ref]
	);

	return size;
};